import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=ed8e5b22&scoped=true"
import script from "./StaffTable.vue?vue&type=script&lang=js"
export * from "./StaffTable.vue?vue&type=script&lang=js"
import style0 from "./StaffTable.vue?vue&type=style&index=0&id=ed8e5b22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8e5b22",
  null
  
)

export default component.exports